import { render, staticRenderFns } from "./References.vue?vue&type=template&id=67b3f73b&scoped=true"
import script from "./References.vue?vue&type=script&lang=js"
export * from "./References.vue?vue&type=script&lang=js"
import style0 from "./References.vue?vue&type=style&index=0&id=67b3f73b&prod&lang=css"
import style1 from "./References.vue?vue&type=style&index=1&id=67b3f73b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b3f73b",
  null
  
)

export default component.exports